import { createContext, useRef, useState } from "react";
import Notification from "../../../../components/toast";
import { SlicedObject } from "../../../../util/libObject";
import { set } from "date-fns";

const ContextRegister = createContext({});

function RegisterProvider({ children, options, fetch, fetchID, insert, fetchIdGroup, fetchSum }) {
	//#region variables
	const [selectData, setSelectData] = useState({}); //dados do registro selecionado, para edição
	const [searchedData, setSearchedData] = useState([]); //lista com os dados da pesquisa, retornados do banco

	const [filterData, setFilterData] = useState([]); //filtro que foi aplicado na pesquisa
	const [filterListData, setFilterListData] = useState({}); //usado no componente lista de filtros, mostra os filtros aplicados

	//Controle de paginação
	const [page, setPage] = useState(1); //page
	const [totalPage, setTotalPage] = useState(0); // endPage // indica que chegou ao fim as pesquisas -> pensar caso adicionar mais e passar para a proxima pagina
	const currentPage = useRef(0); //total Paginas Listadas

	const [isOpenModalFilter, setIsOpenModalFilter] = useState(false);

	const [loading, setLoading] = useState(false);

	const [listDataTotal, setListDataTotal] = useState({});
	const [showSumButton, setShowSumButton] = useState(false);
	const [hasSummed, setHasSummed] = useState(false);
	//#endregion

	const firstFetch = async (filterSelected, filterFormatedList) => {
		try {
			setLoading(true);
			const body = await SlicedObject(filterSelected);

			const response = await fetch(body, 1);

			const data = response.data || [];

			const recordCount = data.length;

			setSearchedData(data);
			// setFilterListData(filterSelected);
			setFilterListData(filterFormatedList);

			// Se a quantidade de itens retornados for menor que 15, está na última página
			if (recordCount < 15) {
				setTotalPage(1);
			} else {
				setTotalPage(0);
				currentPage.current = 1;
			}

			// Atualizar filtro com o número de registros encontrados
			// const filter = { ...filterSelected, recordCount };
			setFilterData(body);

			setPage(1);
			setIsOpenModalFilter(false);

			setListDataTotal({});
			setHasSummed(false);
			setShowSumButton(Boolean(options.hasSum && data.length > 0));
		} catch (error) {
			setSearchedData([]);
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	// busca o resultado completo da pesquisa (mesmos filtros), sem paginação, usado para gerar o relatório
	const fetchAllData = async () => {
		const body = await SlicedObject(filterData);
		const response = await fetch(body, 1, 100000);
		return response?.data || [];
	};

	const nextFetch = async (newPage) => {
		try {
			setLoading(true);

			if (totalPage > 0) return;

			const body = await SlicedObject(filterData);

			const response = await fetch(body, newPage);
			const data = response.data || [];

			if (data.length > 0) {
				setSearchedData((prevDate) => [...prevDate, ...data]);
			}

			// se não encontrou nada ou a quantidade de itens retornados for menor que 15, está na última página
			if (data.length === 0 || data.length < 15) {
				setTotalPage(currentPage.current + 1);
			} else {
				currentPage.current++;
			}
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	const reloadData = async (initialId, currentId) => {
		try {
			setLoading(true);
			//lista o cliente no qual foi feita a inserção ou alteração
			// const response = await reqComplementos.complement(api, currentId);

			const response = await fetchID(currentId);

			//pego somente o primeiro pq neste caso mando sempre 1 resgistro por vez
			const responseData = response.data;

			//se é inserção ou alteração. Inserção só adiciona mais um registro no array
			if (initialId === 0) {
				setSearchedData((prevState) => [...prevState, responseData]);
			} else {
				//se for update ele procura na lista aonde ta o cliente que foi selecionado e altera somente ele
				const newsearchedData = searchedData.map((item) => {
					if (item[options.id] === responseData[options.id]) {
						return responseData;
					}
					return item;
				});
				setSearchedData(newsearchedData);
			}
		} catch (error) {
			setSearchedData([]);
		} finally {
			setLoading(false);
		}
	};

	const reloadFetchFirstData = async (initialId, currentId) => {
		try {
			setLoading(true);

			const response = await fetchIdGroup(currentId);

			const data = response.data || [];

			const recordCount = data.length;

			setSearchedData(data);
			setFilterListData([]);
			setFilterListData([]);

			// Se a quantidade de itens retornados for menor que 15, está na última página
			if (recordCount < 15) {
				setTotalPage(1);
			} else {
				setTotalPage(0);
				currentPage.current = 1;
			}

			// Atualizar filtro com o número de registros encontrados
			// const filter = { ...filterSelected, recordCount };
			setFilterData([]);

			setPage(1);
		} catch (error) {
			setSearchedData([]);
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	// Função para excluir um item de outro componente
	const deleteItemCard = async (itemId) => {
		try {
			setLoading(true);

			// Remove o item do estado local
			setSearchedData((prevData) => prevData.filter((item) => item[options.id] !== itemId));

			Notification.showToast({
				message: "Registro deletado!",
				type: "success",
			});
		} catch (error) {
			Notification.showToast({
				message: error.message || "Erro ao excluir o registro.",
				type: "error",
			});
		} finally {
			setLoading(false);
		}
	};

	const handleSumClick = async () => {
		if (!fetchSum || !filterData) return;

		try {
			setLoading(true);
			const response = await fetchSum(filterData);
			const payload = response?.data || response;
			const result = Array.isArray(payload) ? payload[0] : payload;
			const sumResult = {};

			options.listDataTotal?.forEach((item) => {
				if (result?.[item.key] !== undefined) {
					sumResult[item.key] = {
						label: item.label || item.key,
						value: result[item.key],
						format: item.format || "",
					};
				}
			});

			setListDataTotal(sumResult);
			setShowSumButton(false);
			setHasSummed(true);
		} catch (error) {
			console.error("Erro ao calcular a soma:", error);
			Notification.showToast({
				message: error.message || "Erro ao calcular a soma",
				type: "warning",
			});
		} finally {
			setLoading(false);
		}
	};

	//#region Modal Filter e callback do modal
	const callBackSubmitModalFilter = async (aFilterData, data) => {
		try {
			setLoading(true);

			await firstFetch(data, aFilterData);
			setFilterData(data);

			handleCloseModalFilter();
		} catch (error) {
			console.log(error);

			// handleMessageError(error.message);
		} finally {
			setLoading(false);
		}
	};

	const handleOpenModalFilter = (e) => {
		e.preventDefault();
		const event = new CustomEvent(options.identFilter);
		window.dispatchEvent(event);
	};

	const handleCloseModalFilter = () => {
		const event = new CustomEvent(options.identFilter);
		window.dispatchEvent(event);
	};
	//#endregion

	return (
		<ContextRegister.Provider
			value={{
				options,
				page,
				totalPage,
				currentPage,
				selectData,
				searchedData,
				filterData,
				loading,
				isOpenModalFilter,

				handleOpenModalFilter,
				callBackSubmitModalFilter,
				filterListData,

				setPage,
				setSelectData,
				setSearchedData,
				setFilterData,
				setLoading,
				setIsOpenModalFilter,

				insert,
				fetch,
				fetchID,
				firstFetch,
				nextFetch,
				fetchAllData,
				reloadData,
				reloadFetchFirstData,
				deleteItemCard,

				listDataTotal,
				showSumButton,
				hasSummed,
				handleSumClick,
			}}
		>
			{children}
		</ContextRegister.Provider>
	);
}

export { ContextRegister, RegisterProvider };
